// GETTERS
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_ACCOUNT_ADVERTISER = 'GET_ACCOUNT_ADVERTISER';
export const GET_COUNTRIES_LIST = 'GET_COUNTRIES_LIST';
export const GET_ADVERTISER_LIST = 'GET_ADVERTISER_LIST';
export const GET_SELECTED_CURRENCY = 'GET_SELECTED_CURRENCY';
export const GET_CAMPAIGN_TOTAL_BUDGET = 'GET_CAMPAIGN_TOTAL_BUDGET';
export const GET_CAMPAIGN_TOTAL_IMPRESSION_TARGET = 'GET_CAMPAIGN_TOTAL_IMPRESSION_TARGET';
export const GET_CAMPAIGN_MIN_START_DATE = 'GET_CAMPAIGN_MIN_START_DATE';
export const GET_CAMPAIGN_MAX_END_DATE = 'GET_CAMPAIGN_MAX_END_DATE';
export const GET_IS_MANAGED_CAMPAIGN = 'GET_IS_MANAGED_CAMPAIGN';
export const GET_IS_SELF_SERVICE_CAMPAIGN = 'GET_IS_SELF_SERVICE_CAMPAIGN';
export const GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN = 'GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN';
export const GET_IS_NEW_CAMPAIGN = 'GET_IS_NEW_CAMPAIGN';
export const GET_IS_CAMPAIGN_DRAFT = 'GET_IS_CAMPAIGN_DRAFT';
export const GET_IS_CAMPAIGN_REVIEW = 'GET_IS_CAMPAIGN_REVIEW';
export const GET_IS_CAMPAIGN_LIVE = 'GET_IS_CAMPAIGN_LIVE';
export const GET_IS_CAMPAIGN_DORMANT = 'GET_IS_CAMPAIGN_DORMANT';
export const GET_IS_CAMPAIGN_PAUSED = 'GET_IS_CAMPAIGN_PAUSED';
export const GET_IS_CAMPAIGN_ENDED = 'GET_IS_CAMPAIGN_ENDED';
export const GET_IS_CAMPAIGN_STATE = 'GET_IS_CAMPAIGN_STATE';
export const GET_IS_CAMPAIGN_READONLY = 'GET_IS_CAMPAIGN_READONLY';
export const GET_IS_VIEW_TYPE = 'GET_IS_VIEW_TYPE';
export const GET_ACCESS = 'GET_ACCESS';
export const FETCH_CAMPAIGN_ACCESS = 'FETCH_CAMPAIGN_ACCESS';
export const GET_CAMPAIGN_PERMISSIONS = 'GET_CAMPAIGN_PERMISSIONS';
export const GET_HAS_OWNER_ACCESS = 'GET_HAS_OWNER_ACCESS';
export const GET_HAS_CAMPAIGN_ACCESS = 'GET_HAS_CAMPAIGN_ACCESS';
export const GET_HAS_SHOWCASE_ACCESS = 'GET_HAS_SHOWCASE_ACCESS';
export const GET_ORDERS_START_DATE = 'GET_ORDERS_START_DATE';
export const GET_ORDERS_END_DATE = 'GET_ORDERS_END_DATE';
export const GET_ORDERS_CURRENCY = 'GET_ORDERS_CURRENCY';

// ACTIONS
export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS';
export const FETCH_ORDER = 'FETCH_ORDER';
export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_CAMPAIGNS_FOR_GROUP = 'FETCH_CAMPAIGNS_FOR_GROUP';
export const FETCH_CAMPAIGN_GROUPS = 'FETCH_CAMPAIGN_GROUPS';
export const FETCH_CAMPAIGN_GROUPS_WITH_CAMPAIGNS = 'FETCH_CAMPAIGN_GROUPS_WITH_CAMPAIGNS';
export const FETCH_SHARED_CAMPAIGN_GROUPS_WITH_CAMPAIGNS = 'FETCH_SHARED_CAMPAIGN_GROUPS_WITH_CAMPAIGNS';
export const FETCH_EXISTING_ADVERTISERS = 'FETCH_EXISTING_ADVERTISERS';
export const UPDATE_SELECTED_ADVERTISER = 'UPDATE_SELECTED_ADVERTISER';
export const FETCH_ADVERTISER = 'FETCH_ADVERTISER';
export const FETCH_EXISTING_CONTENT_PROVIDER = 'FETCH_EXISTING_CONTENT_PROVIDER';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const PATCH_CAMPAIGN = 'PATCH_CAMPAIGN';
export const GET_CAMPAIGN_BY_ID = 'GET_CAMPAIGN_BY_ID';
export const GET_CAMPAIGN_BY_NAME = 'GET_CAMPAIGN_BY_NAME';
export const CREATE_ADVERTISER = 'CREATE_ADVERTISER';
export const FETCH_PUBLISHERS = 'FETCH_PUBLISHERS';
export const FETCH_PUBLISHERS_GROUPS = 'FETCH_PUBLISHERS_GROUPS';
export const ADD_PUBLISHER = 'ADD_PUBLISHER';
export const DELETE_PUBLISHER = 'DELETE_PUBLISHER';
export const FETCH_CURRENCIES = 'FETCH_CURRENCIES';
export const CREATE_ORDER = 'CREATE_ORDER';
export const PATCH_ORDER = 'PATCH_ORDER';
export const FETCH_BANNED_WORDS = 'FETCH_BANNED_WORDS';
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const PATCH_BLACKLIST = 'PATCH_BLACKLIST';
export const RESET_CAMPAIGN = 'RESET_CAMPAIGN';
export const SUBMIT_CAMPAIGN = 'SUBMIT_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const COPY_CAMPAIGN = 'COPY_CAMPAIGN';
export const REMOVE_CAMPAIGN = 'REMOVE_CAMPAIGN';
export const SET_CAMPAIGN_LIVE = 'SET_CAMPAIGN_LIVE';
export const FETCH_EXISTING_CAMPAIGN = 'FETCH_EXISTING_CAMPAIGN';
export const FETCH_EXISTING_BLACKLIST = 'FETCH_EXISTING_BLACKLIST';
export const DELETE_ORDER = 'DELETE_ORDER';
export const UPDATE_PUBLISHER_GROUP = 'UPDATE_PUBLISHER_GROUP';
export const FETCH_CREATIVE_SIZES = 'FETCH_CREATIVE_SIZES';
export const FETCH_PUBLISHER_DEALS = 'FETCH_PUBLISHER_DEALS';
export const FETCH_COMMON_COUNTIES = 'FETCH_COMMON_COUNTIES';
export const FETCH_ADX_ADVERTISERS = 'FETCH_ADX_ADVERTISERS';
export const FETCH_DEAL_OVERRIDES = 'FETCH_DEAL_OVERRIDES';
export const UPDATE_DEAL_OVERRIDES = 'UPDATE_DEAL_OVERRIDES';
export const SUBMIT_DEAL_OVERRIDES = 'SUBMIT_DEAL_OVERRIDES';
export const CREATE_DEAL_OVERRIDES = 'CREATE_DEAL_OVERRIDES';
export const FETCH_AGENCIES = 'FETCH_AGENCIES';
export const CREATE_AGENCY = 'CREATE_AGENCY';
export const GET_PUBLISHERS_CREATIVES = 'GET_PUBLISHERS_CREATIVES';
export const UPDATE_PUBLISHERS_CREATIVES = 'UPDATE_PUBLISHERS_CREATIVES';
export const UPLOAD_LOGO_IMAGE = 'UPLOAD_LOGO_IMAGE';
export const PATCH_CAMPAIGN_PROPERTIES = 'PATCH_CAMPAIGN_PROPERTIES';
export const DELETE_CAMPAIGN_LOGO = 'DELETE_CAMPAIGN_LOGO';
export const FETCH_CAMPAIGN_STATES = 'FETCH_CAMPAIGN_STATES';
export const UPDATE_CAMPAIGN_GROUP = 'UPDATE_CAMPAIGN_GROUP';
export const DELETE_CAMPAIGN_GROUP = 'DELETE_CAMPAIGN_GROUP';
export const FETCH_GEO_LOCATIONS = 'FETCH_GEO_LOCATIONS';
export const SET_DORMANT_CAMPAIGN_LIVE = 'SET_DORMANT_CAMPAIGN_LIVE';

// MUTATIONS
export const SET_CAMPAIGNS = 'SET_CAMPAIGNS';
export const SET_CAMPAIGN_GROUPS = 'SET_CAMPAIGN_GROUPS';
export const ADD_CAMPAIGNS = 'ADD_CAMPAIGNS';
export const SET_CAMPAIGN = 'SET_CAMPAIGN';
export const SET_CAMPAIGN_STATS = 'SET_CAMPAIGN_STATS';
export const SET_ORDER = 'SET_ORDER';
export const SET_ORDERS = 'SET_ORDERS';
export const SET_ADVERTISERS = 'SET_ADVERTISERS';
export const SET_SELECTED_ADVERTISER = 'SET_SELECTED_ADVERTISER';
export const SET_CONTENT_PROVIDER = 'SET_CONTENT_PROVIDER';
export const SET_CONTENT_PROVIDER_NAME = 'SET_CONTENT_PROVIDER_NAME';
export const SET_CURRENCIES = 'SET_CURRENCIES';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_LINKING_WORDS = 'SET_LINKING_WORDS';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_REGIONS = 'SET_REGIONS';
export const SET_BLACKLIST = 'SET_BLACKLIST';
export const SET_PUBLISHER_LIST = 'SET_PUBLISHER_LIST';
export const SET_PUBLISHER = 'SET_PUBLISHER';
export const REMOVE_PUBLISHER = 'REMOVE_PUBLISHER';
export const CLEAR_PUBLISHERS = 'CLEAR_PUBLISHERS';
export const SET_PUBLISHER_GROUPS = 'SET_PUBLISHER_GROUPS';
export const SET_ADX_ADVERTISERS = 'SET_ADX_ADVERTISERS';
export const SET_DEAL_OVERRIDES = 'SET_DEAL_OVERRIDES';
export const SET_AGENCIES_LIST = 'SET_AGENCIES_LIST';
export const ADD_AGENCY_TO_LIST = 'ADD_AGENCY_TO_LIST';
export const GET_CAMPAIGN_PROPERTIES = 'GET_CAMPAIGN_PROPERTIES';
export const SET_CAMPAIGN_LOGO = 'SET_CAMPAIGN_LOGO';
export const SET_CAMPAIGN_PROPERTIES = 'SET_CAMPAIGN_PROPERTIES';
export const SET_CAMPAIGN_STATES = 'SET_CAMPAIGN_STATES';
export const ADD_OR_UPDATE_CAMPAIGN_PERMISSIONS = 'ADD_OR_UPDATE_CAMPAIGN_PERMISSIONS';
export const CLEAR_CAMPAIGN_TEMPLATE_GROUP = 'CLEAR_CAMPAIGN_TEMPLATE_GROUP';
export const SET_GEO_LOCATIONS = 'SET_GEO_LOCATIONS';

// MUTATIONS + ACTIONS
export const SET_VIEW_TYPE = 'SET_VIEW_TYPE';
export const SET_CAMPAIGN_STATE = 'SET_CAMPAIGN_STATE';
export const SET_CAMPAIGN_INFO_CHANGES = 'SET_CAMPAIGN_INFO_CHANGES';
